export const BOOTSTRAP_FINANCES_FORMS = 'BOOTSTRAP_FINANCES_FORMS'
export const SET_TOTAL_FINANCES_FORMS = 'SET_TOTAL_FINANCES_FORMS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const ADD_FINANCES_FORMS = 'ADD_FINANCES_FORMS'
export const UPDATE_FINANCES_FORMS = 'UPDATE_FINANCES_FORMS'

